import { LeadPlanItem } from '../../app/features/quoter/services/quoter-api.service';

/** Payload mock derivado de planes.json para GET /lead/{id}/plans */
export const MOCK_LEAD_PLANS: { lead_id: string; uf_value: number; plans: LeadPlanItem[] } = {
  "lead_id": "00QWK00000OmHXR2A3",
  "uf_value": 40820.31,
  "plans": [
    {
      "plan_id": "PROD-00001",
      "plan_code": "SURA_VEH_ESENCIAL",
      "name": "Plan Esencial",
      "workshop_type": "",
      "coverageGroups": {
        "COBERTURAS_VEHICULO": {
          "coverages": [
            {
              "code": "SURA_VEH_LiabilityOwnCargoThirdParty",
              "name": "Daños a terceros por propia carga",
              "description": "Cobertura de responsabilidad civil por daños a terceros causados por la carga transportada en el vehículo asegurado.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_StrikeAndTerrorism",
              "name": "Huelga y terrorismo",
              "description": "Cobertura por daños al vehículo asegurado causados por actos de huelga, sabotaje o terrorismo.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_OwnCargoDamage",
              "name": "Daños materiales por la propia carga",
              "description": "Cobertura por daños materiales al vehículo asegurado ocasionados por la carga que transporta.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_VehicleDamage",
              "name": "Daños al vehículo",
              "description": "Cobertura por daños materiales al vehículo asegurado causados por colisión, vuelco o accidente de tránsito.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_TheftUnauthorizedUse",
              "name": "Robo, hurto o uso no autorizado",
              "description": "Cobertura por pérdida total del vehículo asegurado debido a robo, hurto o uso no autorizado por terceros.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_MaliciousActs",
              "name": "Actos maliciosos",
              "description": "Cobertura por daños al vehículo asegurado causados intencionalmente por terceros.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_Earthquake",
              "name": "Sismo",
              "description": "Cobertura por daños al vehículo asegurado causados por sismo o terremoto.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_NaturalHazards",
              "name": "Riesgos de la naturaleza",
              "description": "Cobertura por daños al vehículo asegurado causados por fenómenos naturales como lluvia, inundación o viento.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_LegalDefenseAndBail",
              "name": "Defensa penal y constitución de fianza",
              "description": "Cobertura de defensa penal y constitución de fianza para el asegurado en causas derivadas de accidentes de tránsito.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_LiabilityMoralDamage",
              "name": "Responsabilidad civil daño moral",
              "description": "Cobertura de responsabilidad civil por daño moral causado a terceros en accidente de tránsito.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_HailDamage",
              "name": "Daños vehículo granizo",
              "description": "Cobertura específica por daños materiales al vehículo asegurado causados por granizo.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_LiabilityLostProfits",
              "name": "Responsabilidad civil lucro cesante",
              "description": "Cobertura de responsabilidad civil por lucro cesante causado a terceros en accidente de tránsito.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_LiabilityEmergentDamage",
              "name": "Responsabilidad civil daño emergente",
              "description": "Cobertura de responsabilidad civil por daños materiales causados a terceros en accidente de tránsito.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_AccessoriesTheft",
              "name": "Robo accesorios",
              "description": "Cobertura por robo de accesorios del vehículo asegurado, con límite en UF y porcentaje del valor comercial.",
              "tax_rate": 0,
              "is_optional": false
            }
          ],
          "icon": "utility:car",
          "displayOrder": 3,
          "groupName": "Coberturas al vehículo asegurado",
          "groupCode": "COBERTURAS_VEHICULO"
        },
        "COBERTURAS_PERSONAS": {
          "coverages": [
            {
              "code": "SURA_VEH_PersonalAccidentsPlanA",
              "name": "Plan A",
              "description": "Cobertura de accidentes personales Plan A para conductor y pasajeros — límite por pasajero y por vehículo expresado en UF.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_PersonalAccidentsPlanB",
              "name": "Plan B",
              "description": "Cobertura de accidentes personales Plan B para conductor y pasajeros — límite por pasajero y por vehículo expresado en UF.",
              "tax_rate": 0,
              "is_optional": false
            }
          ],
          "icon": "utility:user",
          "displayOrder": 2,
          "groupName": "Coberturas a personas",
          "groupCode": "COBERTURAS_PERSONAS"
        },
        "ASISTENCIAS_BASICAS": {
          "coverages": [
            {
              "code": "SURA_VEH_BasicRoadsideAssistance",
              "name": "Asistencia al vehículo básica",
              "description": "Servicio de asistencia básica al vehículo en ruta — incluye grúa, cambio de neumático y asistencia mecánica básica.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_ReplacementVehicle15Days",
              "name": "Auto de reemplazo 15 días",
              "description": "Servicio de vehículo de reemplazo por hasta 15 días en caso de siniestro que deje el vehículo asegurado inoperativo.",
              "tax_rate": 0,
              "is_optional": false
            }
          ],
          "icon": "utility:shield",
          "displayOrder": 1,
          "groupName": "Asistencias básicas",
          "groupCode": "ASISTENCIAS_BASICAS"
        },
        "EXCLUSIONES": {
          "coverages": [],
          "icon": "utility:shield",
          "displayOrder": 4,
          "groupName": "Exclusiones",
          "groupCode": "EXCLUSIONES"
        },
      },
      "main_coverages": [
        "Daños parciales y pérdida total",
        "Actos maliciosos y riesgos varios",
        "Granizo, huelga, terrorismo, naturaleza, sismo",
        "Robo, hurto, uso no autorizado",
        "Indemnización 0km"
      ],
      "coverages": [
        {
          "code": "SURA_VEH_LiabilityOwnCargoThirdParty",
          "name": "",
          "description": "Robo de contenido",
          "tax_rate": 0,
          "is_optional": false,
          "featured": true,
          "coverage_group": {
            "group_code": "EXCLUSIONES",
            "group_name": "Exclusiones",
            "display_order": 4,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_LiabilityOwnCargoThirdParty",
          "name": "",
          "description": "Viajes al extranjero",
          "tax_rate": 0,
          "is_optional": false,
          "featured": true,
          "coverage_group": {
            "group_code": "EXCLUSIONES",
            "group_name": "Exclusiones",
            "display_order": 4,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_LiabilityOwnCargoThirdParty",
          "name": "",
          "description": "Cesantía desempleo involuntario",
          "tax_rate": 0,
          "is_optional": false,
          "featured": true,
          "coverage_group": {
            "group_code": "EXCLUSIONES",
            "group_name": "Exclusiones",
            "display_order": 4,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_LiabilityOwnCargoThirdParty",
          "name": "",
          "description": "Cesantía incapacidad temporal",
          "tax_rate": 0,
          "is_optional": false,
          "featured": true,
          "coverage_group": {
            "group_code": "EXCLUSIONES",
            "group_name": "Exclusiones",
            "display_order": 4,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_LiabilityOwnCargoThirdParty",
          "name": "",
          "description": "Transporte o repatriación sanitaria en caso de lesiones por accidente.",
          "tax_rate": 0,
          "is_optional": false,
          "featured": true,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_StrikeAndTerrorism",
          "name": "",
          "description": "Transporte o repatriación de los asegurados y acompañantes.",
          "tax_rate": 0,
          "is_optional": false,
          "featured": true,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_OwnCargoDamage",
          "name": "",
          "description": "Transporte o repatriación del asegurado fallecido y los demás acompañantes.",
          "tax_rate": 0,
          "is_optional": false,
          "featured": true,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_VehicleDamage",
          "name": "Asistencia legal en gestiones de excarcelación",
          "description": "máximo 12 UF por evento.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_TheftUnauthorizedUse",
          "name": "Reembolso de gastos médicos",
          "description": "por enfermedades en viaje hasta 20 UF (máximo anual 40 UF), por accidente en viaje hasta 40 UF (máximo anual 80 UF), un deducible de 5 UF para titulares que no coticen en el sistema de salud previsional.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_MaliciousActs",
          "name": "Conductor de reemplazo a domicilio",
          "description": "6 eventos al año.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_PersonalAccidentsPlanA",
          "name": "Responsabilidad civil",
          "description": "UF 1.000",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_PERSONAS",
            "group_name": "Coberturas a personas",
            "display_order": 2,
            "icon": "utility:user"
          }
        },
        {
          "code": "SURA_VEH_PersonalAccidentsPlanB",
          "name": "Defensa penal y fianzas",
          "description": "UF 50",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_PERSONAS",
            "group_name": "Coberturas a personas",
            "display_order": 2,
            "icon": "utility:user"
          }
        },
        {
          "code": "SURA_VEH_PersonalAccidentsPlanB",
          "name": "Robo de accesorios",
          "description": "UF 80",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_PERSONAS",
            "group_name": "Coberturas a personas",
            "display_order": 2,
            "icon": "utility:user"
          }
        },
        {
          "code": "SURA_VEH_PersonalAccidentsPlanB",
          "name": "Plan A muerte accidental",
          "description": "UF 200 por asiento. Tope: UF 1.000",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_PERSONAS",
            "group_name": "Coberturas a personas",
            "display_order": 2,
            "icon": "utility:user"
          }
        },
        {
          "code": "SURA_VEH_PersonalAccidentsPlanB",
          "name": "Plan B incapacidad",
          "description": "UF 200 por asiento. Tope: UF 1.000",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_PERSONAS",
            "group_name": "Coberturas a personas",
            "display_order": 2,
            "icon": "utility:user"
          }
        },
        {
          "code": "SURA_VEH_PersonalAccidentsPlanB",
          "name": "",
          "description": "Daños por carga propia y a terceros",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_PERSONAS",
            "group_name": "Coberturas a personas",
            "display_order": 2,
            "icon": "utility:user"
          }
        },
        {
          "code": "SURA_VEH_BasicRoadsideAssistance",
          "name": "Remolque o transporte en caso de avería o accidente",
          "description": "ilimitado, límite por evento 15 UF.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "ASISTENCIAS_BASICAS",
            "group_name": "Asistencias básicas",
            "display_order": 1,
            "icon": "utility:shield"
          }
        },
        {
          "code": "SURA_VEH_ReplacementVehicle15Days",
          "name": "Reparación in situ",
          "description": "6 eventos al año.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "ASISTENCIAS_BASICAS",
            "group_name": "Asistencias básicas",
            "display_order": 1,
            "icon": "utility:shield"
          }
        },
        {
          "code": "SURA_VEH_ReplacementVehicle15Days",
          "name": "Estancia y desplazamiento de los asegurados por inmovilización del vehículo",
          "description": "estancia hasta 3 UF por día y máximo 9 UF por pasajero.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "ASISTENCIAS_BASICAS",
            "group_name": "Asistencias básicas",
            "display_order": 1,
            "icon": "utility:shield"
          }
        }
        ,
        {
          "code": "SURA_VEH_ReplacementVehicle15Days",
          "name": "Estancia y desplazamiento de los asegurados por robo del vehículo",
          "description": "una vez hecha la denuncia, aplica estancia hasta 3 UF por día y máximo 9 UF por pasajero.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "ASISTENCIAS_BASICAS",
            "group_name": "Asistencias básicas",
            "display_order": 1,
            "icon": "utility:shield"
          }
        }
        ,
        {
          "code": "SURA_VEH_ReplacementVehicle15Days",
          "name": "Servicio de conductor profesional",
          "description": "si hay un accidente y no hay conductor, se proporcionará uno a cargo del pasajero.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "ASISTENCIAS_BASICAS",
            "group_name": "Asistencias básicas",
            "display_order": 1,
            "icon": "utility:shield"
          }
        }
      ],
      "deductibles": [
        {
          "is_default": false,
          "premium_gross_local": 427389,
          "premium_gross_indexed": 10.47,
          "premium_net_local": 427389,
          "premium_net_indexed": 10.47,
          "amount_local": 0,
          "amount_indexed": 0,
          "id": "UF0"
        },
        {
          "is_default": false,
          "premium_gross_local": 325746,
          "premium_gross_indexed": 7.98,
          "premium_net_local": 325746,
          "premium_net_indexed": 7.98,
          "amount_local": 122461,
          "amount_indexed": 3,
          "id": "UF3"
        },
        {
          "is_default": true,
          "premium_gross_local": 303703,
          "premium_gross_indexed": 7.44,
          "premium_net_local": 303703,
          "premium_net_indexed": 7.44,
          "amount_local": 204102,
          "amount_indexed": 5,
          "id": "UF5"
        },
        {
          "is_default": false,
          "premium_gross_local": 271863,
          "premium_gross_indexed": 6.66,
          "premium_net_local": 271863,
          "premium_net_indexed": 6.66,
          "amount_local": 408203,
          "amount_indexed": 10,
          "id": "UF10"
        }
      ],
      "base_premium": {
        "installment_indexed": 0.62,
        "installment_local": 25309,
        "monthly_gross_indexed": 0.62,
        "monthly_gross_local": 25309,
        "gross_indexed": 7.44,
        "gross_local": 303703,
        "tax": 0,
        "net_indexed": 7.44,
        "net_local": 303703
      }
    },
    {
      "plan_id": "PROD-00002",
      "plan_code": "SURA_VEH_TOTAL",
      "name": "Plan Total",
      "workshop_type": "",
      "coverageGroups": {
        "COBERTURAS_VEHICULO": {
          "coverages": [
            {
              "code": "SURA_VEH_OwnCargoDamage",
              "name": "Daños materiales por la propia carga",
              "description": "Cobertura por daños materiales al vehículo asegurado ocasionados por la carga que transporta.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_LiabilityLostProfits",
              "name": "Responsabilidad civil lucro cesante",
              "description": "Cobertura de responsabilidad civil por lucro cesante causado a terceros en accidente de tránsito.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_AccessoriesTheft",
              "name": "Robo accesorios",
              "description": "Cobertura por robo de accesorios del vehículo asegurado, con límite en UF y porcentaje del valor comercial.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_StrikeAndTerrorism",
              "name": "Huelga y terrorismo",
              "description": "Cobertura por daños al vehículo asegurado causados por actos de huelga, sabotaje o terrorismo.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_Earthquake",
              "name": "Sismo",
              "description": "Cobertura por daños al vehículo asegurado causados por sismo o terremoto.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_NaturalHazards",
              "name": "Riesgos de la naturaleza",
              "description": "Cobertura por daños al vehículo asegurado causados por fenómenos naturales como lluvia, inundación o viento.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_VehicleDamage",
              "name": "Daños al vehículo",
              "description": "Cobertura por daños materiales al vehículo asegurado causados por colisión, vuelco o accidente de tránsito.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_LiabilityOwnCargoThirdParty",
              "name": "Daños a terceros por propia carga",
              "description": "Cobertura de responsabilidad civil por daños a terceros causados por la carga transportada en el vehículo asegurado.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_TheftUnauthorizedUse",
              "name": "Robo, hurto o uso no autorizado",
              "description": "Cobertura por pérdida total del vehículo asegurado debido a robo, hurto o uso no autorizado por terceros.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_HailDamage",
              "name": "Daños vehículo granizo",
              "description": "Cobertura específica por daños materiales al vehículo asegurado causados por granizo.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_LiabilityEmergentDamage",
              "name": "Responsabilidad civil daño emergente",
              "description": "Cobertura de responsabilidad civil por daños materiales causados a terceros en accidente de tránsito.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_MaliciousActs",
              "name": "Actos maliciosos",
              "description": "Cobertura por daños al vehículo asegurado causados intencionalmente por terceros.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_LiabilityMoralDamage",
              "name": "Responsabilidad civil daño moral",
              "description": "Cobertura de responsabilidad civil por daño moral causado a terceros en accidente de tránsito.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_LegalDefenseAndBail",
              "name": "Defensa penal y constitución de fianza",
              "description": "Cobertura de defensa penal y constitución de fianza para el asegurado en causas derivadas de accidentes de tránsito.",
              "tax_rate": 0,
              "is_optional": false
            }
          ],
          "icon": "utility:car",
          "displayOrder": 3,
          "groupName": "Coberturas al vehículo asegurado",
          "groupCode": "COBERTURAS_VEHICULO"
        },
        "COBERTURAS_PERSONAS": {
          "coverages": [
            {
              "code": "SURA_VEH_PersonalAccidentsPlanB",
              "name": "Plan B",
              "description": "Cobertura de accidentes personales Plan B para conductor y pasajeros — límite por pasajero y por vehículo expresado en UF.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_PersonalAccidentsPlanA",
              "name": "Plan A",
              "description": "Cobertura de accidentes personales Plan A para conductor y pasajeros — límite por pasajero y por vehículo expresado en UF.",
              "tax_rate": 0,
              "is_optional": false
            }
          ],
          "icon": "utility:user",
          "displayOrder": 2,
          "groupName": "Coberturas a personas",
          "groupCode": "COBERTURAS_PERSONAS"
        },
        "ASISTENCIAS_BASICAS": {
          "coverages": [
            {
              "code": "SURA_VEH_ReplacementVehicle30Days",
              "name": "Auto de reemplazo 30 días",
              "description": "Servicio de vehículo de reemplazo por hasta 30 días en caso de siniestro que deje el vehículo asegurado inoperativo.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_FullRoadsideAssistance",
              "name": "Asistencia al vehículo full",
              "description": "Servicio de asistencia completa al vehículo en ruta — incluye grúa, cambio de neumático, asistencia mecánica y servicios adicionales.",
              "tax_rate": 0,
              "is_optional": false
            }
          ],
          "icon": "utility:shield",
          "displayOrder": 1,
          "groupName": "Asistencias Full",
          "groupCode": "ASISTENCIAS_BASICAS"
        },
        "EXCLUSIONES": {
          "coverages": [],
          "icon": "utility:shield",
          "displayOrder": 4,
          "groupName": "Exclusiones",
          "groupCode": "EXCLUSIONES"
        },
      },
      "main_coverages": [
        "Daños parciales y pérdida total",
        "Actos maliciosos y riesgos varios",
        "Granizo, huelga, terrorismo, naturaleza, sismo",
        "Robo, hurto, uso no autorizado",
        "Indemnización 0km"
      ],
      "coverages": [
        {
          "code": "SURA_VEH_LiabilityMoralDamage",
          "name": "",
          "description": "Daños por carga propia",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "EXCLUSIONES",
            "group_name": "Exclusiones",
            "display_order": 4,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_LiabilityMoralDamage",
          "name": "",
          "description": "Daños a terceros por carga",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "EXCLUSIONES",
            "group_name": "Exclusiones",
            "display_order": 4,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_LiabilityMoralDamage",
          "name": "",
          "description": "Cesantía desempleo involuntario",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "EXCLUSIONES",
            "group_name": "Exclusiones",
            "display_order": 4,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_LiabilityMoralDamage",
          "name": "",
          "description": "Cesantía incapacidad temporal",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "EXCLUSIONES",
            "group_name": "Exclusiones",
            "display_order": 4,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_OwnCargoDamage",
          "name": "Remolque o transporte por avería o accidente del vehículo",
          "description": "máximo 12 UF.",
          "tax_rate": 0,
          "is_optional": false,
          "featured": true,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_LiabilityLostProfits",
          "name": "Servicio de reparación in situ",
          "description": "cualquier reparación no mayor a 30 minutos de duración.",
          "tax_rate": 0,
          "is_optional": false,
          "featured": true,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_AccessoriesTheft",
          "name": "Transporte, depósito o custodia del vehículo reparado y recuperado",
          "description": "hasta 12 UF si la reparación requiere un tiempo mayor a 72 horas.",
          "tax_rate": 0,
          "is_optional": false,
          "featured": true,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_StrikeAndTerrorism",
          "name": "Servicio de conductor profesional",
          "description": "se ofrece el servicio por accidente o enfermedad.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_Earthquake",
          "name": "",
          "description": "Localización y envío de repuestos al taller donde se encuentre el vehículo.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_NaturalHazards",
          "name": "Estancia y desplazamiento por inmovilización del vehículo por avería o accidente",
          "description": "estancia en hotel hasta 3 UF por día, con un máximo de 9 UF por ocupante. O el desplazamiento de los ocupantes hasta el domicilio o el lugar de destino.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_VehicleDamage",
          "name": "Estancia y desplazamiento por robo del vehículo",
          "description": "proporcionamos estancia en hotel hasta 3 UF por día, con un máximo de 9 UF por ocupante. O el desplazamiento de los ocupantes hasta el domicilio o el lugar de destino.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_LiabilityOwnCargoThirdParty",
          "name": "",
          "description": "Transmisión de mensajes urgentes producto a la contingencia.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_TheftUnauthorizedUse",
          "name": "",
          "description": "Transporte de los acompañantes en caso de accidente.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_HailDamage",
          "name": "",
          "description": "Transporte sanitario en caso de lesiones por accidente de tránsito.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_LiabilityEmergentDamage",
          "name": "",
          "description": "Transporte del cliente fallecido y demás acompañantes.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_MaliciousActs",
          "name": "Reembolso de gastos médicos de los ocupantes del vehículo",
          "description": "cubrimos por atenciones médicas y hospitalarias hasta 20 UF con tope anual de 40 UF.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_LiabilityMoralDamage",
          "name": "Asistencia legal en gestiones de excarcelación",
          "description": "máximo 14 UF.",
          "tax_rate": 0,
          "is_optional": false,
          "featured": true,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_LegalDefenseAndBail",
          "name": "Anticipo de fianzas",
          "description": "máximo 6 UF.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_LegalDefenseAndBail",
          "name": "Consulta y orientación legal telefónica las 24 horas",
          "description": "durante todos los días del año.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_LegalDefenseAndBail",
          "name": "Representación y tramitación de infracciones",
          "description": "aplica solamente para la gestión.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_LegalDefenseAndBail",
          "name": "Asesoría y tramitación de documentación por compraventa de vehículos",
          "description": "esta cobertura considera un copago de $5.000 por la gestión.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_LegalDefenseAndBail",
          "name": "Tramitación de documentación en el Registro Civil",
          "description": "apoyo de personal jurídico para gestionar los trámites. Esta cobertura considera un copago de $5.000 por la gestión.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_LegalDefenseAndBail",
          "name": "Asesoría en contratación, cambio y devolución del TAG",
          "description": "esta cobertura considera un copago de $5.000 por la gestión.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_LegalDefenseAndBail",
          "name": "Tramitación de documentación en las direcciones de tránsito",
          "description": "esta cobertura considera un copago de $5.000 por la gestión.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_LegalDefenseAndBail",
          "name": "Conductor de reemplazo:",
          "description": "2 eventos al año sin costo.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_LegalDefenseAndBail",
          "name": "Revisión Técnica Express:",
          "description": "1 evento al año.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_LegalDefenseAndBail",
          "name": "Conducción al lugar del mantenimiento",
          "description": "1 evento al año.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_LegalDefenseAndBail",
          "name": "Servicio complementario vehículo de reemplazo por reparación",
          "description": "máximo de 3 días hábiles sin costo y con un copago de $8.000 a partir del cuarto día. 1 evento al año.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_LegalDefenseAndBail",
          "name": "Traslado seguro preventivo en taxi en caso de ingesta de alcohol",
          "description": "hasta 6 eventos al año sin copago.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_LegalDefenseAndBail",
          "name": "Traslado del asegurado desde o hacia el aeropuerto por conductor profesional",
          "description": "2 eventos al año.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_LegalDefenseAndBail",
          "name": "Revisión del vehículo por vacaciones por mecánico certificado",
          "description": "2 eventos al año.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_LegalDefenseAndBail",
          "name": "Servicio adicional de vehículo de reemplazo",
          "description": "deducible máximo de 10 UF.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_PersonalAccidentsPlanB",
          "name": "Responsabilidad civil",
          "description": "UF 2.000",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_PERSONAS",
            "group_name": "Coberturas a personas",
            "display_order": 2,
            "icon": "utility:user"
          }
        },
        {
          "code": "SURA_VEH_PersonalAccidentsPlanA",
          "name": "Defensa penal y fianzas",
          "description": "UF 100",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_PERSONAS",
            "group_name": "Coberturas a personas",
            "display_order": 2,
            "icon": "utility:user"
          }
        },
        {
          "code": "SURA_VEH_PersonalAccidentsPlanA",
          "name": "Robo de accesorios",
          "description": "UF 100",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_PERSONAS",
            "group_name": "Coberturas a personas",
            "display_order": 2,
            "icon": "utility:user"
          }
        },
        {
          "code": "SURA_VEH_PersonalAccidentsPlanA",
          "name": "Plan A muerte accidental",
          "description": "UF 200 por asiento. Tope: UF 1.000",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_PERSONAS",
            "group_name": "Coberturas a personas",
            "display_order": 2,
            "icon": "utility:user"
          }
        },
        {
          "code": "SURA_VEH_PersonalAccidentsPlanA",
          "name": "Plan B incapacidad",
          "description": "UF 200 por asiento. Tope: UF 1.000",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_PERSONAS",
            "group_name": "Coberturas a personas",
            "display_order": 2,
            "icon": "utility:user"
          }
        },
        {
          "code": "SURA_VEH_PersonalAccidentsPlanA",
          "name": "",
          "description": "Robo de contenido y viajes al extranjero",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_PERSONAS",
            "group_name": "Coberturas a personas",
            "display_order": 2,
            "icon": "utility:user"
          }
        },
        {
          "code": "SURA_VEH_ReplacementVehicle30Days",
          "name": "Vehículo de reemplazo",
          "description": "30 días",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "ASISTENCIAS_BASICAS",
            "group_name": "Asistencias básicas",
            "display_order": 1,
            "icon": "utility:shield"
          }
        },
        {
          "code": "SURA_VEH_FullRoadsideAssistance",
          "name": "Taller",
          "description": "multimarca o garantía",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "ASISTENCIAS_BASICAS",
            "group_name": "Asistencias básicas",
            "display_order": 1,
            "icon": "utility:shield"
          }
        },
        {
          "code": "SURA_VEH_FullRoadsideAssistance",
          "name": "Asistencia vehicular",
          "description": "full",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "ASISTENCIAS_BASICAS",
            "group_name": "Asistencias básicas",
            "display_order": 1,
            "icon": "utility:shield"
          }
        }
      ],
      "deductibles": [
        {
          "is_default": false,
          "premium_gross_local": 502090,
          "premium_gross_indexed": 12.3,
          "premium_net_local": 502090,
          "premium_net_indexed": 12.3,
          "amount_local": 0,
          "amount_indexed": 0,
          "id": "UF0"
        },
        {
          "is_default": false,
          "premium_gross_local": 390650,
          "premium_gross_indexed": 9.57,
          "premium_net_local": 390650,
          "premium_net_indexed": 9.57,
          "amount_local": 122461,
          "amount_indexed": 3,
          "id": "UF3"
        },
        {
          "is_default": true,
          "premium_gross_local": 366566,
          "premium_gross_indexed": 8.98,
          "premium_net_local": 366566,
          "premium_net_indexed": 8.98,
          "amount_local": 204102,
          "amount_indexed": 5,
          "id": "UF5"
        },
        {
          "is_default": false,
          "premium_gross_local": 331053,
          "premium_gross_indexed": 8.11,
          "premium_net_local": 331053,
          "premium_net_indexed": 8.11,
          "amount_local": 408203,
          "amount_indexed": 10,
          "id": "UF10"
        }
      ],
      "base_premium": {
        "installment_indexed": 0.75,
        "installment_local": 30547,
        "monthly_gross_indexed": 0.75,
        "monthly_gross_local": 30547,
        "gross_indexed": 8.98,
        "gross_local": 366566,
        "tax": 0,
        "net_indexed": 8.98,
        "net_local": 366566
      }
    },
    {
      "plan_id": "PROD-00003",
      "plan_code": "SURA_VEH_FULL",
      "name": "Plan Full",
      "workshop_type": "",
      "coverageGroups": {
        "COBERTURAS_VEHICULO": {
          "coverages": [
            {
              "code": "SURA_VEH_LiabilityMoralDamage",
              "name": "Responsabilidad civil daño moral",
              "description": "Cobertura de responsabilidad civil por daño moral causado a terceros en accidente de tránsito.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_LiabilityOwnCargoThirdParty",
              "name": "Daños a terceros por propia carga",
              "description": "Cobertura de responsabilidad civil por daños a terceros causados por la carga transportada en el vehículo asegurado.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_Earthquake",
              "name": "Sismo",
              "description": "Cobertura por daños al vehículo asegurado causados por sismo o terremoto.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_AbroadTravelDamage",
              "name": "Daños vehículo viaje extranjero",
              "description": "Cobertura por daños materiales al vehículo asegurado ocurridos durante viajes fuera del territorio nacional.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_ContentTheftWithViolence",
              "name": "Robo contenido violencia y fuerza",
              "description": "Cobertura por robo de pertenencias personales dentro del vehículo asegurado, perpetrado con violencia o fuerza sobre las cosas.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_StrikeAndTerrorism",
              "name": "Huelga y terrorismo",
              "description": "Cobertura por daños al vehículo asegurado causados por actos de huelga, sabotaje o terrorismo.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_HailDamage",
              "name": "Daños vehículo granizo",
              "description": "Cobertura específica por daños materiales al vehículo asegurado causados por granizo.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_OwnCargoDamage",
              "name": "Daños materiales por la propia carga",
              "description": "Cobertura por daños materiales al vehículo asegurado ocasionados por la carga que transporta.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_AccessoriesTheft",
              "name": "Robo accesorios",
              "description": "Cobertura por robo de accesorios del vehículo asegurado, con límite en UF y porcentaje del valor comercial.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_LegalDefenseAndBail",
              "name": "Defensa penal y constitución de fianza",
              "description": "Cobertura de defensa penal y constitución de fianza para el asegurado en causas derivadas de accidentes de tránsito.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_LiabilityEmergentDamage",
              "name": "Responsabilidad civil daño emergente",
              "description": "Cobertura de responsabilidad civil por daños materiales causados a terceros en accidente de tránsito.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_MaliciousActs",
              "name": "Actos maliciosos",
              "description": "Cobertura por daños al vehículo asegurado causados intencionalmente por terceros.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_LiabilityLostProfits",
              "name": "Responsabilidad civil lucro cesante",
              "description": "Cobertura de responsabilidad civil por lucro cesante causado a terceros en accidente de tránsito.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_NaturalHazards",
              "name": "Riesgos de la naturaleza",
              "description": "Cobertura por daños al vehículo asegurado causados por fenómenos naturales como lluvia, inundación o viento.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_TheftUnauthorizedUse",
              "name": "Robo, hurto o uso no autorizado",
              "description": "Cobertura por pérdida total del vehículo asegurado debido a robo, hurto o uso no autorizado por terceros.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_VehicleDamage",
              "name": "Daños al vehículo",
              "description": "Cobertura por daños materiales al vehículo asegurado causados por colisión, vuelco o accidente de tránsito.",
              "tax_rate": 0,
              "is_optional": false
            }
          ],
          "icon": "utility:car",
          "displayOrder": 3,
          "groupName": "Coberturas al vehículo asegurado",
          "groupCode": "COBERTURAS_VEHICULO"
        },
        "COBERTURAS_PERSONAS": {
          "coverages": [
            {
              "code": "SURA_VEH_TemporaryDisabilityCoverage",
              "name": "Cesantía incapacidad temporal",
              "description": "Cobertura de cesantía por incapacidad temporal — pago de cuotas de prima durante el período de incapacidad.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_PersonalAccidentsPlanB",
              "name": "Plan B",
              "description": "Cobertura de accidentes personales Plan B para conductor y pasajeros — límite por pasajero y por vehículo expresado en UF.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_UnemploymentCoverage",
              "name": "Cesantía desempleo involuntario",
              "description": "Cobertura de cesantía por desempleo involuntario — pago de cuotas de prima durante el período de cesantía.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_PersonalAccidentsPlanA",
              "name": "Plan A",
              "description": "Cobertura de accidentes personales Plan A para conductor y pasajeros — límite por pasajero y por vehículo expresado en UF.",
              "tax_rate": 0,
              "is_optional": false
            }
          ],
          "icon": "utility:user",
          "displayOrder": 2,
          "groupName": "Coberturas a personas",
          "groupCode": "COBERTURAS_PERSONAS"
        },
        "ASISTENCIAS_BASICAS": {
          "coverages": [
            {
              "code": "SURA_VEH_ReplacementVehicleUnlimited",
              "name": "Auto de reemplazo ilimitado",
              "description": "Servicio de vehículo de reemplazo sin límite de días en caso de siniestro que deje el vehículo asegurado inoperativo.",
              "tax_rate": 0,
              "is_optional": false
            },
            {
              "code": "SURA_VEH_FullRoadsideAssistance",
              "name": "Asistencia al vehículo full",
              "description": "Servicio de asistencia completa al vehículo en ruta — incluye grúa, cambio de neumático, asistencia mecánica y servicios adicionales.",
              "tax_rate": 0,
              "is_optional": false
            }
          ],
          "icon": "utility:shield",
          "displayOrder": 1,
          "groupName": "Asistencias full ilimitadas",
          "groupCode": "ASISTENCIAS_BASICAS"
        },
        "EXCLUSIONES": {
          "coverages": [],
          "icon": "utility:shield",
          "displayOrder": 4,
          "groupName": "Exclusiones",
          "groupCode": "EXCLUSIONES"
        },
      },
      "main_coverages": [
        "Daños parciales y pérdida total",
        "Actos maliciosos y riesgos varios",
        "Granizo, huelga, terrorismo, naturaleza, sismo",
        "Robo, hurto, uso no autorizado",
        "Indemnización 0km"
      ],
      "coverages": [
        {
          "code": "SURA_VEH_LiabilityMoralDamage",
          "name": "",
          "description": "Los servicios que el asegurado haya concertado por su cuenta, sin previo consentimiento de la compañía, salvo que la comunicación haya sido imposible por fuerza mayor.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "EXCLUSIONES",
            "group_name": "Exclusiones",
            "display_order": 4,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_LiabilityMoralDamage",
          "name": "",
          "description": "Las asistencias derivadas de prácticas deportivas en competición.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "EXCLUSIONES",
            "group_name": "Exclusiones",
            "display_order": 4,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_LiabilityMoralDamage",
          "name": "",
          "description": "La compañía queda relevada de responsabilidad cuando por causa de fuerza mayor le sea imposible prestar las acciones de asistencia previstas en esta póliza, sin perjuicio de las indemnizaciones a que hubiere lugar, las que pagarán contra prestación de los comprobantes de gastos respectivos que presente el asegurado y hasta concurrencia de los límites que se señalan anteriormente.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "EXCLUSIONES",
            "group_name": "Exclusiones",
            "display_order": 4,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_LiabilityMoralDamage",
          "name": "Remolque o transporte por avería o accidente del vehículo",
          "description": "máximo 15 UF.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_LiabilityOwnCargoThirdParty",
          "name": "Servicio de reparación in situ",
          "description": "cualquier reparación no mayor a 30 minutos de duración.",
          "tax_rate": 0,
          "is_optional": false,
          "featured": true,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_Earthquake",
          "name": "Transporte, depósito o custodia del vehículo reparado y recuperado",
          "description": "hasta 12 UF si la reparación requiere un tiempo mayor a 72 horas.",
          "tax_rate": 0,
          "is_optional": false,
          "featured": true,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_AbroadTravelDamage",
          "name": "Servicio de conductor profesional",
          "description": "se ofrece el servicio por accidente o enfermedad.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_ContentTheftWithViolence",
          "name": "",
          "description": "Localización y envío de repuestos al taller donde se encuentre el vehículo.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_StrikeAndTerrorism",
          "name": "Estancia y desplazamiento por inmovilización del vehículo por avería o accidente",
          "description": "estancia en hotel hasta 3 UF por día, con un máximo de 9 UF por ocupante. O el desplazamiento de los ocupantes hasta el domicilio o el lugar de destino.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_HailDamage",
          "name": "Estancia y desplazamiento por robo del vehículo",
          "description": "proporcionamos estancia en hotel hasta 3 UF por día, con un máximo de 9 UF por ocupante. O el desplazamiento de los ocupantes hasta el domicilio o el lugar de destino.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_OwnCargoDamage",
          "name": "",
          "description": "Transmisión de mensajes urgentes producto a la contingencia.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_AccessoriesTheft",
          "name": "",
          "description": "Transporte de los acompañantes en caso de accidente.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_LegalDefenseAndBail",
          "name": "",
          "description": "Transporte sanitario en caso de lesiones por accidente de tránsito.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_LiabilityEmergentDamage",
          "name": "",
          "description": "Transporte del cliente fallecido y demás acompañantes.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_MaliciousActs",
          "name": "Reembolso de gastos médicos de los ocupantes del vehículo",
          "description": "cubrimos por atenciones médicas y hospitalarias hasta 20 UF con tope anual de 40 UF.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_LiabilityLostProfits",
          "name": "Asistencia legal en gestiones de excarcelación",
          "description": "máximo 14 UF.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_NaturalHazards",
          "name": "Anticipo de fianzas",
          "description": "máximo 6 UF.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_TheftUnauthorizedUse",
          "name": "Consulta y orientación legal telefónica las 24 horas",
          "description": "durante todos los días del año.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_VehicleDamage",
          "name": "Representación y tramitación de infracciones",
          "description": "aplica solamente para la gestión.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_VehicleDamage",
          "name": "Asesoría y tramitación de documentación por compraventa de vehículos",
          "description": "esta cobertura considera un copago de $5.000 por la gestión.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_VehicleDamage",
          "name": "Tramitación de documentación en el Registro Civil",
          "description": "apoyo de personal jurídico para gestionar los trámites. Esta cobertura considera un copago de $5.000 por la gestión.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_VehicleDamage",
          "name": "Asesoría en contratación, cambio y devolución del TAG:",
          "description": "esta cobertura considera un copago de $5.000 por la gestión.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_VehicleDamage",
          "name": "Tramitación de documentación en las direcciones de tránsito",
          "description": "esta cobertura considera un copago de $5.000 por la gestión.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_VehicleDamage",
          "name": "Conductor de reemplazo",
          "description": "2 eventos al año sin costo.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_VehicleDamage",
          "name": "Revisión del vehículo por vacaciones por mecánico certificado",
          "description": "2 eventos al año.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_VehicleDamage",
          "name": "Servicio adicional de vehículo de reemplazo",
          "description": "deducible máximo de 15 UF.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_VehicleDamage",
          "name": "Revisión Técnica Express",
          "description": "1 evento al año.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_VehicleDamage",
          "name": "Conducción al lugar del mantenimiento",
          "description": "1 evento al año.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_VehicleDamage",
          "name": "Servicio complementario vehículo de reemplazo por reparación",
          "description": "máximo de 3 días hábiles sin costo y con un copago de $8.000 a partir del cuarto día. 1 evento al año.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_VehicleDamage",
          "name": "Traslado seguro preventivo en taxi en caso de ingesta de alcohol",
          "description": "hasta 6 eventos al año sin copago.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_VehicleDamage",
          "name": "Traslado del asegurado desde o hacia el aeropuerto por conductor profesional",
          "description": "2 eventos al año.",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_VEHICULO",
            "group_name": "Coberturas al vehículo asegurado",
            "display_order": 3,
            "icon": "utility:car"
          }
        },
        {
          "code": "SURA_VEH_TemporaryDisabilityCoverage",
          "name": "Responsabilidad civil:",
          "description": "UF 3.000",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_PERSONAS",
            "group_name": "Coberturas a personas",
            "display_order": 2,
            "icon": "utility:user"
          }
        },
        {
          "code": "SURA_VEH_PersonalAccidentsPlanB",
          "name": "Defensa penal y fianzas",
          "description": "UF 150",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_PERSONAS",
            "group_name": "Coberturas a personas",
            "display_order": 2,
            "icon": "utility:user"
          }
        },
        {
          "code": "SURA_VEH_UnemploymentCoverage",
          "name": "Robo de accesorios",
          "description": "UF 120",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_PERSONAS",
            "group_name": "Coberturas a personas",
            "display_order": 2,
            "icon": "utility:user"
          }
        },
        {
          "code": "SURA_VEH_PersonalAccidentsPlanA",
          "name": "Plan A muerte accidental",
          "description": "UF 200 por asiento. Tope: UF 1.000",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_PERSONAS",
            "group_name": "Coberturas a personas",
            "display_order": 2,
            "icon": "utility:user"
          }
        },
        {
          "code": "SURA_VEH_PersonalAccidentsPlanA",
          "name": "Plan B incapacidad",
          "description": "UF 200 por asiento. Tope: UF 1.000",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_PERSONAS",
            "group_name": "Coberturas a personas",
            "display_order": 2,
            "icon": "utility:user"
          }
        },
        {
          "code": "SURA_VEH_PersonalAccidentsPlanA",
          "name": "Daños por carga propia",
          "description": "Valor comercial",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_PERSONAS",
            "group_name": "Coberturas a personas",
            "display_order": 2,
            "icon": "utility:user"
          }
        },
        {
          "code": "SURA_VEH_PersonalAccidentsPlanA",
          "name": "Daños a terceros por carga",
          "description": "UF 1.000",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_PERSONAS",
            "group_name": "Coberturas a personas",
            "display_order": 2,
            "icon": "utility:user"
          }
        },
        {
          "code": "SURA_VEH_PersonalAccidentsPlanA",
          "name": "",
          "description": "Robo de contenido",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_PERSONAS",
            "group_name": "Coberturas a personas",
            "display_order": 2,
            "icon": "utility:user"
          }
        },
        {
          "code": "SURA_VEH_PersonalAccidentsPlanA",
          "name": "",
          "description": "Viajes al extranjero",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_PERSONAS",
            "group_name": "Coberturas a personas",
            "display_order": 2,
            "icon": "utility:user"
          }
        },
        {
          "code": "SURA_VEH_PersonalAccidentsPlanA",
          "name": "Cesantía desempleo involuntario",
          "description": "UF 5 (3 cuotas)",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_PERSONAS",
            "group_name": "Coberturas a personas",
            "display_order": 2,
            "icon": "utility:user"
          }
        },
        {
          "code": "SURA_VEH_PersonalAccidentsPlanA",
          "name": "Cesantía de incapacidad temporal",
          "description": "UF 13 (3 cuotas)",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "COBERTURAS_PERSONAS",
            "group_name": "Coberturas a personas",
            "display_order": 2,
            "icon": "utility:user"
          }
        },
        {
          "code": "SURA_VEH_ReplacementVehicleUnlimited",
          "name": "Vehículo de reemplazo",
          "description": "ilimitado",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "ASISTENCIAS_BASICAS",
            "group_name": "Asistencias básicas",
            "display_order": 1,
            "icon": "utility:shield"
          }
        },
        {
          "code": "SURA_VEH_FullRoadsideAssistance",
          "name": "Taller",
          "description": "Marca",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "ASISTENCIAS_BASICAS",
            "group_name": "Asistencias básicas",
            "display_order": 1,
            "icon": "utility:shield"
          }
        },
        {
          "code": "SURA_VEH_FullRoadsideAssistance",
          "name": "Asistencia vehicular",
          "description": "Full + extras (viaje, hospedaje, conductor)",
          "tax_rate": 0,
          "is_optional": false,
          "coverage_group": {
            "group_code": "ASISTENCIAS_BASICAS",
            "group_name": "Asistencias básicas",
            "display_order": 1,
            "icon": "utility:shield"
          }
        }
      ],
      "deductibles": [
        {
          "is_default": false,
          "premium_gross_local": 816406,
          "premium_gross_indexed": 20,
          "premium_net_local": 816406,
          "premium_net_indexed": 20,
          "amount_local": 0,
          "amount_indexed": 0,
          "id": "UF0"
        },
        {
          "is_default": false,
          "premium_gross_local": 649451,
          "premium_gross_indexed": 15.91,
          "premium_net_local": 649451,
          "premium_net_indexed": 15.91,
          "amount_local": 122461,
          "amount_indexed": 3,
          "id": "UF3"
        },
        {
          "is_default": true,
          "premium_gross_local": 612305,
          "premium_gross_indexed": 15,
          "premium_net_local": 612305,
          "premium_net_indexed": 15,
          "amount_local": 204102,
          "amount_indexed": 5,
          "id": "UF5"
        },
        {
          "is_default": false,
          "premium_gross_local": 557605,
          "premium_gross_indexed": 13.66,
          "premium_net_local": 557605,
          "premium_net_indexed": 13.66,
          "amount_local": 408203,
          "amount_indexed": 10,
          "id": "UF10"
        }
      ],
      "base_premium": {
        "installment_indexed": 1.25,
        "installment_local": 51025,
        "monthly_gross_indexed": 1.25,
        "monthly_gross_local": 51025,
        "gross_indexed": 15,
        "gross_local": 612305,
        "tax": 0,
        "net_indexed": 15,
        "net_local": 612305
      }
    }
  ]
};
